module.exports = __webpack_public_path__ + "img/account.2f16cacd.gif";